export default "__VITE_ASSET__6oMEgdYk__"